import { useEffect, useState } from "react"
import { daggerText } from "../../icons"
import "./footer.component.css"
import useCheckForMobileHook from "../../hooks/useCheckForMobileHook"
import SiteMenuComponent from "../site-menu/site-menu.component"
import PixelComponent from "../pixel/pixel.component"
import { useLocation } from "react-router-dom"

const openContactForm = (defaultSubject) => {
  document.dispatchEvent(
    new CustomEvent("EVENTS.OPEN_CONTACT_FORM", {
      detail: { defaultSubject },
    }),
  )
}

const FooterComponent = () => {
  const [items, setItems] = useState({})
  const isMobile = useCheckForMobileHook()
  const { pathname } = useLocation()
  const normalizedPath = pathname.toLowerCase().replace(/\/+$/, "").trim()
  const isHomeRoute = ["", "/", "/home-clone", "/home"].includes(normalizedPath)

  // Get items on header event
  useEffect(() => {
    const loadItems = () => {
      const store = window.sessionStorage.getItem("__dagger-store__")
      if (store) {
        setItems(JSON.parse(store).header)
      }
    }

    document.addEventListener("EVENTS.HEADER_LOADED", loadItems)
    loadItems()
    return () => document.removeEventListener("EVENTS.HEADER_LOADED", loadItems)
  }, [])

  return (
    <footer
      className={`dagger-footer ${isHomeRoute ? "is-home-footer" : "non-home-footer"}`}
    >
      <PixelComponent anchor="bottom-left" className="dagger-footer-pixel" />
      <div className="dagger-footer-content">
        <div className="dagger-footer-content-top">
          <div className="dagger-footer-content-top-menu">
            <SiteMenuComponent items={items} />
            {isMobile && items.SocialOutlets?.length > 0 && (
              <div className="dagger-footer-content-top-extras-bottom mobile-only">
                <h2>{items.SocialHeading}</h2>
                <div className="dagger-footer-content-top-extras-bottom-social">
                  {items.SocialOutlets.filter(Boolean).map((s) => {
                    return (
                      <a
                        key={s.id}
                        href={s.LinkUrl}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={s.Media?.data?.attributes?.url} alt={s.Name} />
                      </a>
                    )
                  })}
                </div>
              </div>
            )}
          </div>
          <div className="dagger-footer-content-top-extra-group">
            <div className="dagger-footer-content-top-extras">
              <h2>{items.AddressHeading}</h2>
              {items.ContactAddressLineOne}
              <br />
              {items.ContactAddressLineTwo}
              <br />
              {items.ContactAddressLineThree}
            </div>
            <div className="dagger-footer-content-top-extras">
              <h2>{items.ContactHeading}</h2>
              {items.ContactPhone && (
                <a href={`tel:+1${items.ContactPhone.replaceAll(".", "")}`}>
                  {items.ContactPhone}
                </a>
              )}
              <a href={`mailto:${items.NewBusinessEmail}`}>
                {items.NewBusinessEmail}
              </a>
              <a
                className="underline"
                href="#contact"
                onClick={(e) => {
                  e.preventDefault()
                  openContactForm("General Inquiry")
                }}
              >
                Contact
              </a>
              {/* <h2>{items.PressCaption}:</h2>
              {items.PressName && <>{items.PressName}</>}
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault()
                  openContactForm("Press")
                }}
              >
                {items.PressEmail}
              </a>
              <h2>{items.NewBusinessCaption}:</h2>
              {items.NewBusinessName && (
                <>
                  {items.NewBusinessName}
                  <br />
                </>
              )}
              {items.NewBusinessTitle && <>{items.NewBusinessTitle}</>}
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault()
                  openContactForm("New Business")
                }}
              >
                {items.NewBusinessEmail}
              </a> */}
            </div>
          </div>
        </div>
        <div className="dagger-footer-wordmark">{daggerText}</div>
      </div>
      <div className="dagger-footer-legal">
        &copy; {items.CopyrightText}
        <div className="dagger-footer-legal-links">
          <a href={`/${items.TermsPrivacyPage?.data?.attributes?.Slug}`}>
            TERMS + PRIVACY POLICY
          </a>
          {/* <a target="_blank" rel="noreferrer" href={items.PlanIssuerLink}>
            PLAN + ISSUER PRICE TRANSPARENCY
          </a> */}
        </div>
      </div>
    </footer>
  )
}

export default FooterComponent
